// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appKpisList/getData', async ({ setBlock, ...params }) => {

  setBlock(true)

  const response = await axios.get('/apps/kpislist/list', params)

  setBlock(false)

  return {
    params,
    data:           response.data.kpis_list,
    dataAsi:        response.data.kpis_list_asi,
    allData:        response.data.allData,
    totalPages:     response.data.total,
    totalPagesAsi:  response.data.total_asi
  }
})

export const appKpisListSlice = createSlice({
  name: 'appKpisList',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data        = action.payload.data
      state.dataAsi     = action.payload.dataAsi
      state.allData     = action.payload.allData
      state.total       = action.payload.totalPages
      state.totalAsi    = action.payload.totalPagesAsi
      state.params      = action.payload.params
    })
  }
})

export default appKpisListSlice.reducer
